import {
  View,
  Text,
  ActivityIndicator,
  TextInput
} from 'react-native'
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view'
import Card from '../../shared/card/Card'
import { Formik } from 'formik'
import CustomButton from '../../shared/button/Button'
import { globalStyles } from '../../../static/styles/global'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import { usePersonalStore } from '../../../stores/personalInfo'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import SelectKeyValue from '../../shared/form/SelectKeyValue'
import Toast from 'react-native-toast-message'
import * as yup from 'yup'
import { mapSelectValue } from '../../../utils'

const IlInformationForm = ({ navigation, route }: any) => {
    const { params } = route
    const {
        mostRecentUserOnBoardings: userId,
        mode,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey
    } = params

    const { loading, postilonline } = useFormsStore()
    const personalstore = usePersonalStore()
    const initializestore = useInitializeStore()

    const options1 = [
        { key: 1, value: 'No' },
        { key: 2, value: 'Yes' }
    ]

    const intialValues = {
        exempt: null,
        basicallowances: "",
        additionalallowances: "",
        withheldfromeachpay: "",
        martialstatus: ""
    }
    const w4schema = () => {
        const baseSchema = {
            exempt: yup.string().nullable(),
            basicallowances: yup.string().nullable(),
            additionalallowances: yup.string().nullable(),
            withheldfromeachpay: yup.string().nullable(),
            martialstatus: yup.string().required("Martial status is a required field")

        }
        return yup.object(baseSchema)
    }
    const schema = w4schema()

    const handleResetValues = (props: any) => {
        props.setFieldValue('basicallowances', "")
        props.setFieldValue('additionalallowances', "")
        props.setFieldValue('withheldfromeachpay', "")
    }

    const options2 = [
        { key: 1, value: 'Single' },
        { key: 2, value: 'Married' },
        { key: 3, value: 'Married but withhold as single' }
    ]
    return (
        <KeyboardAwareScrollView
      enableOnAndroid={true}
      enableAutomaticScroll={true}
      enableResetScrollToCoords={false}
      keyboardShouldPersistTaps="handled"
      keyboardDismissMode="interactive"
      showsVerticalScrollIndicator={false}
      extraScrollHeight={80}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: 20 }}
    >
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'IL Withholding Taxation '}
                    />
                </View>
            </View>
            <View style={globalStyles.containerOverlap}>
                <Formik
                    initialValues={{ ...intialValues }}
                    validationSchema={schema}
                    onSubmit={async (values, actions) => {
                        const data = {
                            completeOnline: mode === 'upload' ? false : true,
                            essUserKey: initializestore.initializeData?.userkey,
                            entityId: personalstore.personalData?.entityId,
                            essUserOnBoardingFormKey: essUserOnBoardingFormKey,
                            essObKey: essUserOnBoardingKey,
                            exempt: values?.exempt,
                            basicAllowances: values?.basicallowances ? Number(values?.basicallowances) : null,
                            additionalAllowances: values?.additionalallowances ? Number(values?.additionalallowances) : null,
                            withheldFromEachPay: values?.withheldfromeachpay ? Number(values?.withheldfromeachpay) : null,
                            maritalStatus: values?.martialstatus
                        }

                        const response = await postilonline(data)
                        if (response?.success) {
                            if (mode === 'online') {
                                navigation.navigate('IlInformationOnline', {
                                    userId,
                                    mode,
                                    essUserOnBoardingKey,
                                    essUserOnBoardingFormKey,
                                    values
                                })
                            } else {
                                await Toast.show({
                                    type: 'success',
                                    position: 'bottom',
                                    text1: response?.message,
                                    visibilityTime: 3000,
                                    autoHide: true,
                                    topOffset: 60,
                                    onHide: () => {
                                        navigation.replace('OnboardingForms')
                                    }
                                })
                            }
                        } else {
                            await Toast.show({
                                type: 'error',
                                position: 'bottom',
                                text1: response?.message,
                                visibilityTime: 3000,
                                autoHide: true,
                                topOffset: 60
                            })
                        }

                    }}
                >
                    {(props) => (
                        <View>
                            <Card>

                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Martial Status *'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: "hidden" }}>
                                        <SelectKeyValue
                                            title="Martial Status"
                                            options={options2}
                                            selectedOption={mapSelectValue(
                                                options2,
                                                props.values.martialstatus
                                            )}
                                            onSelect={(option: any) => {
                                                if (option == 1 || option == 3) {
                                                    props.setFieldValue('martialstatus', "S")

                                                }
                                                else {
                                                    props.setFieldValue('martialstatus', "M")

                                                }
                                            }}
                                            textColor="primary"
                                        />{props.touched.martialstatus && props.errors.martialstatus && (
                                            <Text style={globalStyles.dangerAlert}>
                                                {props.errors.martialstatus}
                                            </Text>
                                        )}

                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ justifyContent: 'center', width: '65%' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Are you claiming exempt from federal and Illinois income tax withholding'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <SelectKeyValue
                                            title="Are you claiming exempt from federal and Illinois income tax withholding "
                                            options={options1}
                                            selectedOption={mapSelectValue(
                                                options1,
                                                props.values.exempt
                                            )}
                                            onSelect={(option: any) => {
                                                const val = option - 1
                                                props.setFieldValue('exempt', val)
                                                if (val === 1) {
                                                    props.setFieldValue('withheldfromeachpay', '')
                                                }
                                            }}
                                            textColor="primary"
                                        />
                                        {props.touched.exempt &&
                                            props.errors.exempt && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.exempt as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>




                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {
                                                'Enter the total number of basic allowances that you are claiming'
                                            }
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.basicallowances}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('basicallowances')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.basicallowances &&
                                            props.errors.basicallowances && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.basicallowances}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                <View
                                    style={[
                                        globalStyles.hDirection,
                                        globalStyles.hBetweenItems,
                                        globalStyles.mb2
                                    ]}
                                >
                                    <View style={{ width: '65%', justifyContent: 'center' }}>
                                        <Text
                                            style={[
                                                globalStyles.inputLabel,
                                                globalStyles.inputLabelLarge,
                                                globalStyles.inputLabelPrimary
                                            ]}
                                        >
                                            {'Enter the total number of additional allowances that you are claiming'}
                                        </Text>
                                    </View>
                                    <View style={{ width: '30%', overflow: 'hidden' }}>
                                        <TextInput
                                            style={[globalStyles.input, globalStyles.inputLight]}
                                            value={props.values.additionalallowances}
                                            keyboardType="numeric"
                                            onChangeText={(text) => {
                                                if (text === '' || /^\d+$/.test(text)) {
                                                    props.handleChange('additionalallowances')(text)
                                                }
                                            }}
                                        />
                                        {props.touched.additionalallowances &&
                                            props.errors.additionalallowances && (
                                                <Text style={globalStyles.dangerAlert}>
                                                    {props.errors.additionalallowances as string}
                                                </Text>
                                            )}
                                    </View>
                                </View>
                                {Number(props.values.exempt) !== 1 && (
                                    <View
                                        style={[
                                            globalStyles.hDirection,
                                            globalStyles.hBetweenItems,
                                            globalStyles.mb2
                                        ]}
                                    >
                                        <View style={{ justifyContent: 'center', width: '65%' }}>
                                            <Text
                                                style={[
                                                    globalStyles.inputLabel,
                                                    globalStyles.inputLabelLarge,
                                                    globalStyles.inputLabelPrimary
                                                ]}
                                            >
                                                {
                                                    'Enter the additional amount you want withheld(deducted) from each pay'
                                                }
                                            </Text>
                                        </View>
                                        <View style={{ width: '30%', overflow: 'hidden' }}>
                                            <TextInput
                                                style={[globalStyles.input, globalStyles.inputLight]}
                                                value={props.values.withheldfromeachpay}
                                                keyboardType="numeric"
                                                onChangeText={(text) => {
                                                    if (text === '' || /^\d+$/.test(text)) {
                                                        props.handleChange('withheldfromeachpay')(text)
                                                    }
                                                }}
                                            />
                                            {props.touched.withheldfromeachpay &&
                                                props.errors.withheldfromeachpay && (
                                                    <Text style={globalStyles.dangerAlert}>
                                                        {props.errors.withheldfromeachpay as string}
                                                    </Text>
                                                )}
                                        </View>
                                    </View>
                                )}





                                {loading ? (
                                    <ActivityIndicator />
                                ) : (
                                    <View style={{ margin: 10 }}>
                                        <CustomButton
                                            text={mode === 'upload' ? 'Submit Information' : 'Next'}
                                            onPress={props.handleSubmit}
                                        />
                                    </View>
                                )}
                            </Card>
                        </View>
                    )}
                </Formik>
            </View>

        </KeyboardAwareScrollView>
    )
}

export default IlInformationForm
